export default __webpack_public_path__ + "static/media/d32.c755bd18.png";